import type { Router } from 'vue-router';
import axios from 'axios';

import i18n from '@/plugins/i18n';
import useApiErrors from '@/components/composables/useApiErrors';

export function routeToAppointmentErrorScreen(router: Router, warehouseId: string, error: unknown) {
  const { makeErrorScreenParams } = useApiErrors();
  const { t } = i18n.global;

  if (axios.isAxiosError(error)) {
    const errorParams = makeErrorScreenParams(error);
    return router.push({
      name: 'appointment-error',
      query: { ...errorParams, warehouseId }
    });
  }

  return router.push({
    name: 'appointment-error',
    query: {
      icon: 'mdi-alert-circle-outline',
      title: t('errors.api.genericTitle'),
      backEnabled: '1',
      message: '',
      warehouseId
    }
  });
}
